module.exports = "<captain-app-versions-page></captain-app-versions-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/captainAppVersionsView.html
// module id = 2177
// module chunks = 0